import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { TableStaffCE } from "../../../components/Users/TableStaffCE/TableStaffCE";
import { useAuth } from "../../../hook/userAuth";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { AddEditStaffCE } from "../../../components/Users/TableStaffCE/AddEditStaffCE";
import { ControlPeriodo } from "../../../components/Users/TableStaffCE/ControlPeriodo/ControlPeriodo";
import { Navigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import Swal from "sweetalert2";

function GestionPersonalCe() {
  const { auth } = useAuth();
  if (!auth?.me?.is_superuser) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaGestionPersonalCe />;
}

function LogicaGestionPersonalCe() {
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingPeriodos, setLoadingPeriodos] = useState(true);
  const [personales, setPersonales] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [activeTab, setActiveTab] = useState("alta"); // Estado para rastrear la pestaña activa
  const [periodoIR, setperiodoIR] = useState({});

  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getUsersApi() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/users/?es_docente=false&es_personal_control_escolar=true&is_superuser=false`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      setLoading(false);
      setPersonales(result);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function getPeriodo() {
    try {
      setLoadingPeriodos(true);
      const response = await axios.get(
        `${BASE_API}/api/periodo_reinscripcion/`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      setLoadingPeriodos(false);
      const periodoR = result[0];

      // Verificar si se encontró el periodo de reinscripción
      if (periodoR) {
        setperiodoIR({
          id_periodo_reinscripcion: periodoR.id_periodo_reinscripcion,
          fecha_inicio: periodoR.fecha_inicio,
          hora_inicio: periodoR.hora_inicio,
          fecha_fin: periodoR.fecha_fin,
          hora_fin: periodoR.hora_fin,
        });
      } else {
        setperiodoIR(null);
      }
      return result;
    } catch (error) {
      setLoadingPeriodos(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getUsersApi();
    getPeriodo();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const ondelete = async (datosUsuario) => {
    const confirmMessage = `¿Seguro que desea eliminar definitivamente al usuario con la siguiente curp: ${datosUsuario.curp}?
    (Esta acción no se puede deshacer)`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/users/${datosUsuario.id}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {
        window.location.reload();
        window.location.href = "/Login";
      }
    }
  };

  const createPersonalCE = () => {
    setTitleModal("Nuevo personal Control escolar");
    setContentModal(
      <AddEditStaffCE onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updatePersonalCE = (data) => {
    setTitleModal("Actualizar datos Personal Control Escolar");
    setContentModal(
      <AddEditStaffCE
        onClose={openCloseModal}
        onRefetch={onRefetch}
        PersonalCE={data}
      />
    );
    openCloseModal();
  };

  const renderContent = () => {
    // Función para renderizar el contenido según la pestaña activa
    switch (activeTab) {
      case "alta":
        return (
          <>
            <HeaderPage
              btnTitulo="Registrar nuevo personal"
              btnClick={createPersonalCE}
            />
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TableStaffCE
                personales={personales}
                deletePersonal={ondelete}
                updatePersonalCE={updatePersonalCE}
              />
            )}
            <ModalBasic
              show={showModal}
              title={titleModal}
              children={contentModal}
              close={openCloseModal}
            />
          </>
        );
      case "control":
        return (
          <>
            Asignación de periodo Inscipción/Reinscripción
            {loadingPeriodos ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <ControlPeriodo periodoIR={periodoIR} />
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <h1 className="tituloin">Gestión control escolar</h1>
      <div className="ui top attached tabular menu">
        <button
          className={`item ${activeTab === "alta" ? "active" : ""}`}
          onClick={() => setActiveTab("alta")}
        >
          Alta personal control escolar
        </button>
        <button
          className={`item ${activeTab === "control" ? "active" : ""}`}
          onClick={() => setActiveTab("control")}
        >
          Control periodo Inscripción/Resinscripción
        </button>
        <div className="right menu">
          <div className="item"></div>
        </div>
      </div>
      <div className="ui bottom attached segment">{renderContent()}</div>
    </>
  );
}

export default GestionPersonalCe;
